import { $toast } from "vuetify-snackbar-toast";
import store from "@/store";
import authService from "../../Services/AuthService";

const semPermissao = async (to, from, next) => {
  let currentUser = store.getters["Auth/user"];

  if (!currentUser) {
    await authService.syncUserWithStore();
  }
  currentUser = store.getters["Auth/user"];
  if (currentUser.id !== 943) {
    if (currentUser.roleName !== "super-admin") {
      $toast.warn("Você não tem permissão para acessar esta página");
      next({ name: "logout" });
    }
  }
};

export default semPermissao;
